import t from "react";
class a extends t.Component {
  constructor(r) {
    super(r), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(r) {
    return { hasError: !0 };
  }
  // oxlint-disable-next-line class-methods-use-this
  componentDidCatch(r, o) {
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
export {
  a as ErrorBoundary
};
